import React from 'react';

export default function Analytics() {
    return (
        <>
            <div>
                <h1>Sign Up for cron job goes here</h1>
            </div>
            <div>
                <h1>Analytics of not completion rate</h1>
            </div>
        </>
    )
}